import CreateCPRepositoryImpl from './impl/CreateCPRepositoryImpl'

export default {
  getInstance () {
    return new CreateCPRepositoryImpl()
  }
}
